import styled from 'styled-components'
import { pageGutter } from 'styles/gutter'
import { MediaQueries } from 'utils/breakpoints'

export const NavbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: sticky;
  width: 100%;
  top: 0px;
  z-index: 3;
  padding: 0 24px;
  background-color: #fff;

  ${MediaQueries.medium} {
    padding: 0 40px;
  }
`

export const NavbarButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const NavbarContent = styled.div`
  ${pageGutter}
  border-bottom: 1px solid #ced0dd;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
`

export const FloatContainerCloseIconWrapper = styled.div`
  display: inline-flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  background: #f0f1f7;
  cursor: pointer;
`

export const NavbarLogo = styled.img`
  height: 40px;
  width: auto;
`

export const NavItemContainer = styled.div`
  display: block;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0;
  color: #25272d;
  font-family: 'Source Sans 3';
  font-weight: bold;
  text-decoration: none;
  font-size: 32px;
  line-height: 40px;

  ${MediaQueries.medium} {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
  }
`

type NavListContainer = {
  direction?: string
}

export const NavListContainer = styled.div<NavListContainer>`
  width: 100%;
  display: flex;

  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0;

  ${MediaQueries.medium} {
    flex-direction: row;
    justify-content: center;
    gap: 24px;
  }
`
